/**
 * =============================================================================
 * Componente: StatusBar (helper compartilhado)
 * Versão: 1.0.0
 *
 * Descrição:
 *   Barra lateral colorida usada como primeiro <TableCell> nas listagens do
 *   módulo Indicação (Afiliados, Indicações, Comissões, Pagamentos), garantindo
 *   espessura, altura mínima e cantos arredondados padronizados.
 *
 *   Substitui implementações duplicadas (`w-1 h-full min-h-[40px] rounded-full`)
 *   por uma fonte única de verdade, prevenindo divergências visuais entre
 *   tabelas (caso ReferralReferralsTableView v1.0 que usava `w-1.5` sem rounded).
 *
 * Uso:
 *   <TableCell className="p-0 w-2">
 *     <StatusBar colorClass="bg-yellow-500" />
 *   </TableCell>
 *
 * RELEASE:
 *   2026-04-26 v1.0.0 - Criação inicial.
 * =============================================================================
 */
import { cn } from '@/lib/utils';

interface StatusBarProps {
  /** Classe Tailwind de background (ex: `bg-yellow-500`). */
  colorClass: string;
  /** Classes adicionais opcionais. */
  className?: string;
}

export function StatusBar({ colorClass, className }: StatusBarProps) {
  return (
    <div
      className={cn(
        'w-1 h-full min-h-[40px] rounded-full',
        colorClass,
        className,
      )}
    />
  );
}
